import { BagSdkConfig } from "../sdk";

export type SdkMethodContext = BagSdkConfig & {
  xSiteOrigin?: string;
};

export type BagSdkMethod<T> = (context: SdkMethodContext) => T;

export function initialiseMethod<T>(
  context: SdkMethodContext,
  method: BagSdkMethod<T>,
): T {
  return method(context);
}
